import { connect } from 'react-redux';
import { defineMessages, injectIntl } from 'react-intl';
import _get from 'lodash/get';
import {
  callActions as nucleusCallActions,
  callSelectors as nucleusCallSelectors,
  conferenceParticipantsSelectors,
  conferenceRemoteModeratorsSelectors,
  conferenceSelectors,
  moderatorActions,
  featureSelectors,
  userProfileSelectors
} from '@lifesize/nucleus';
import { setPillNotificationWithTimeout } from 'actions/Notification';
import { openInCallModal } from 'actions/InCallModal';
import actions from 'actions/InCall/InCallDrawer';
import InCallParticipantList from 'components/InCall/InCallParticipantList/InCallParticipantList';
import { ADD_PARTICIPANT_DRAWER } from 'constants/AddParticipantDrawer';
import { participantFilterType } from 'constants/ParticipantList';
import Modals from 'constants/Modals';
import { FLAG_PARTICIPANT_SEARCH, FLAG_RAISE_HAND } from 'constants/FeatureFlags';
import { sortedParticipantListSelector } from 'selectors/call';

const messages = defineMessages({
  muteAll: { id: 'components.incall.footer.notification.muteall', defaultMessage: 'All participants are now muted. They cannot unmute themselves.' },
  unMuteAll: { id: 'components.incall.footer.notification.unMuteAll', defaultMessage: 'All participants are now unmuted, unless they have muted themselves.' }
});

const mapDispatchtoProps = (dispatch, { intl }) => ({
  onAddParticipantClicked: () => (dispatch(actions.openInCallDrawer(ADD_PARTICIPANT_DRAWER))),
  onLockMeetingClicked: (isMeetingLocked) => {
    if (isMeetingLocked) {
      dispatch(moderatorActions.unlockCurrentConference());
    } else {
      dispatch(moderatorActions.lockCurrentConference());
    }
  },
  onLowerAllHandsClicked: () => {
    dispatch(moderatorActions.lowerAllRaisedHands());
  },
  onLowerHandClicked: (participantId) => {
    dispatch(moderatorActions.lowerParticipantHand(participantId));
  },
  onMuteAllClicked: (mute) => {
    dispatch(nucleusCallActions.muteAll(mute)).then(() => {
      dispatch(setPillNotificationWithTimeout(
        intl.formatMessage(mute ? messages.muteAll : messages.unMuteAll))
      );
    });
  },
  onMuteParticipantClicked: (participant) => {
    dispatch(nucleusCallActions.muteParticipant(participant, !participant.serverAudioMuteState));
  },
  onSelectRaisedHandClicked: (participantId) => {
    // TODO: stretch goal is to use this to select the participant (give them the floor); for now, just lower hand
    dispatch(moderatorActions.lowerParticipantHand(participantId));
  },
  onStopPresenterClicked: participant => dispatch(openInCallModal(Modals.stopPresenter, { participant })),
  removeFromMeetingClicked: participant => dispatch(openInCallModal(Modals.removeFromMeeting, { participant }))
});

const mapStateToProps = (state, ownProps) => {
  const {
    callFullyConnected,
    canMuteAll,
    isModerator
  } = nucleusCallSelectors.activeCallSelector(state);
  const canChangeMeetingLock = conferenceSelectors.selectCanLockConference(state) || conferenceSelectors.selectCanUnlockConference(state);
  const isAudioMutedByServer = conferenceSelectors.selectServerAudioMuteState(state);
  const isMeetingLocked = conferenceSelectors.selectIsLocked(state);
  const isLockedByModerator = isMeetingLocked && !isModerator;
  const participants = sortedParticipantListSelector(state);
  const lecturers = participants.filter(p => p.isLecturer); // should be one or none, but returning an array for consistency
  const moderators = participants.filter(p => p.isModerator);
  const raisedHands = conferenceParticipantsSelectors.selectParticipantsWithRaisedHands(state);
  const remoteModerators = conferenceRemoteModeratorsSelectors.selectRemoteModeratorList(state);
  const unmuted = participants.filter(p => (!(p.localAudioMuteState || p.serverAudioMuteState)));
  const showLowerAllHandsButton = !!featureSelectors.getFeatureFlag(state)(FLAG_RAISE_HAND);
  const allowParticipantSearch = !!featureSelectors.getFeatureFlag(state)(FLAG_PARTICIPANT_SEARCH);

  const getParticipants = () => {
    switch (ownProps.participantFilter) {
      case participantFilterType.raisedHands:
        return raisedHands;
      case participantFilterType.unmuted:
        return unmuted;
      default:
        return participants;
    }
  };

  return {
    allowParticipantSearch,
    callFullyConnected,
    canChangeMeetingLock,
    canMuteAll,
    isGuest: userProfileSelectors.selectIsGuest(state),
    isLockedByModerator,
    isMeetingLocked,
    isAudioMutedByServer,
    isModerator,
    lecturers,
    moderators,
    participants: getParticipants(),
    participantsCount: _get(participants, 'length') || 0,
    raisedHandsCount: _get(raisedHands, 'length') || 0,
    remoteModerators,
    unmutedCount: _get(unmuted, 'length') || 0,
    showLowerAllHandsButton
  };
};

export default injectIntl(connect(mapStateToProps, mapDispatchtoProps)(InCallParticipantList));
